"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3850],{

/***/ 66565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CheckboxSVG = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.55491 13.1098C10.1751 13.1098 13.1098 10.1751 13.1098 6.55491C13.1098 2.93474 10.1751 0 6.55491 0C2.93474 0 0 2.93474 0 6.55491C0 10.1751 2.93474 13.1098 6.55491 13.1098ZM9.86117 5.0764C10.0949 4.76985 10.0358 4.33187 9.72927 4.09817C9.42271 3.86446 8.98474 3.92352 8.75103 4.23008L6.16635 7.62044L4.90602 6.10805C4.65924 5.81192 4.21912 5.7719 3.92299 6.01868C3.62685 6.26546 3.58684 6.70558 3.83362 7.00172L6.21491 9.85927L9.86117 5.0764Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxSVG);


/***/ }),

/***/ 13850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ carousel_selectable_product_cards_grid_component; }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/default-props.js
/* harmony default export */ var default_props = ({
    theme: "Black",
    cards: [
        {
            useCases: [
                {
                    useCase: "Social media planner"
                },
                {
                    useCase: "Marketing strategy"
                },
                {
                    useCase: "Content calendar"
                },
                {
                    useCase: "Campaign planning"
                }
            ],
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Creative.png",
            tag: {
                tagText: "Creative & Design",
                tagBackgroundColor: "Brand & WM Primary Color",
                overridePageCluster: "marketing"
            },
            productType: "work-management"
        },
        {
            useCases: [
                {
                    useCase: "Project management"
                },
                {
                    useCase: "Task management"
                },
                {
                    useCase: "Resource management"
                },
                {
                    useCase: "Portfolio management"
                }
            ],
            tag: {
                tagText: "Sales & CRM",
                overridePageCluster: "crm",
                tagBackgroundColor: "Marketer Lighter Tint 01"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/CRM.png"
        },
        {
            useCases: [
                {
                    useCase: "Design tasks"
                },
                {
                    useCase: "Digital Asset Management "
                },
                {
                    useCase: "Creative requests"
                },
                {
                    useCase: "Client campaigns "
                }
            ],
            tag: {
                tagText: "HR",
                tagBackgroundColor: "brand-green-dark-tint-01"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/HR.png"
        },
        {
            useCases: [
                {
                    useCase: "Sales pipeline"
                },
                {
                    useCase: "Lead management"
                },
                {
                    useCase: "Mass email & tracking"
                },
                {
                    useCase: "Contact management"
                }
            ],
            tag: {
                tagText: "Projects & Tasks",
                tagBackgroundColor: "CRM Primary color",
                overridePageCluster: "product_management"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Projects.png"
        },
        {
            useCases: [
                {
                    useCase: "IT service desk"
                },
                {
                    useCase: "Incident management"
                },
                {
                    useCase: "Inventory management "
                },
                {
                    useCase: "SLA tracking"
                }
            ],
            tag: {
                tagText: "Product & Dev",
                tagBackgroundColor: "Projects Primary Color"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Dev.png"
        },
        {
            useCases: [
                {
                    useCase: "Event management "
                },
                {
                    useCase: "Facilities requests"
                },
                {
                    useCase: "Finance requests "
                },
                {
                    useCase: "Order management "
                }
            ],
            tag: {
                tagText: "Marketing",
                tagBackgroundColor: "Projects Lighter Tint 01",
                overridePageCluster: "marketing"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Marketing.png"
        },
        {
            useCases: [
                {
                    useCase: "Roadmap planning"
                },
                {
                    useCase: "Sprint management "
                },
                {
                    useCase: "Feature backlog "
                },
                {
                    useCase: "Bug tracking"
                }
            ],
            tag: {
                tagText: "IT & Support",
                tagBackgroundColor: "Projects Darkest Tint 03",
                overridePageCluster: "information_technology"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/IT.png"
        },
        {
            useCases: [
                {
                    useCase: "Recruitment pipeline"
                },
                {
                    useCase: "Engagement survey"
                },
                {
                    useCase: "HR requests"
                },
                {
                    useCase: "Onboarding & offboarding"
                }
            ],
            tag: {
                tagText: "Operations",
                tagBackgroundColor: "Brand Yellow (darker) Tint 02",
                overridePageCluster: "generic"
            }
        }
    ]
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-card/checkbox-icon.js
var checkbox_icon = __webpack_require__(66565);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/selectable-product-card/selectable-product-card.scss.js





var CARD_WIDTH = 314;
var CARD_HORIZONTAL_MARGIN = 8;
var SMALLER_CARDS_WIDTH = 280;
var StyledSelectableProductCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12tz96g0"
})("cursor:pointer;width:", CARD_WIDTH, "px;margin:0 ", CARD_HORIZONTAL_MARGIN, "px;border-radius:12px;position:relative;overflow:hidden;&:hover{.card-content{opacity:1;}}.card-details{position:absolute;top:0;left:0;padding:20px;display:flex;flex-direction:column;gap:4px;.paragraph-body{font-size:2.25rem;line-height:42px;font-weight:600;color:", colors/* default.White */.Z.White, ";}.product-icon{height:36px;}}.picture-wrapper{display:flex;justify-content:center;.picture-component{display:flex;img{border-radius:8px;width:100%;}}}.card-content{opacity:0;position:absolute;top:0;left:0;width:100%;height:100%;padding:28px 20px 20px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;background:rgba(0,0,0,0.8);backdrop-filter:blur(2.5px);transition:opacity 0.3s ease-in-out;.title{font-size:0.875rem;color:#c3c6d4;}.use-cases-wrapper{display:flex;flex-direction:column;flex-wrap:wrap;gap:12px;padding:20px 0 32px;.use-case{display:flex;gap:4px;align-items:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}.product-logo-wrapper{.picture-component{display:flex;img{height:48px;}}}.product-signup-wrapper{display:flex;}}@media (max-width:", vp_sizes/* MD_DESKTOP_WIDTH */.JF, "){width:", SMALLER_CARDS_WIDTH, "px;}");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/consts.js

var CAROUSEL_PROPS = {
    dots: false,
    centerMode: false,
    infinite: true,
    slidesToScroll: 2,
    draggable: false,
    easing: "ease-in-out",
    arrows: true,
    focusOnSelect: false,
    showFocusEffect: false
};


var _obj;
var PRODUCT_ID_TO_LOGO = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/3-6-2024/wm.png"), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/3-6-2024/crm.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/3-6-2024/dev.png"), (0,_define_property/* default */.Z)(_obj, products/* SERVICE_PRODUCT_ID */.Ai, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/3-6-2024/service.png"), _obj);
var _obj1;
var PRODUCT_ID_TO_COLOR = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.WORK_OS_IRIS_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARK_TINT_01_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, color_consts.DARK_DEV_GREEN_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* SERVICE_PRODUCT_ID */.Ai, color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME), _obj1);
var _obj2;
var BUTTON_CONFIG_BY_PRODUCT = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, {
    signupProductId: products/* WORK_MANAGEMENT_PRODUCT_ID */.py
}), (0,_define_property/* default */.Z)(_obj2, products/* CRM_PRODUCT_ID */.$, {
    signupProductId: products/* CRM_PRODUCT_ID */.$
}), (0,_define_property/* default */.Z)(_obj2, products/* DEV_PRODUCT_ID */.xi, {
    signupProductId: products/* DEV_PRODUCT_ID */.xi
}), (0,_define_property/* default */.Z)(_obj2, products/* SERVICE_PRODUCT_ID */.Ai, {
    signupProductId: products/* SERVICE_PRODUCT_ID */.Ai
}), _obj2);

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/selectable-product-card/selectable-product-card.js
function selectable_product_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_product_card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var SelectableProductCard = function(param) {
    var cardAsset = param.cardAsset, useCases = param.useCases, productType = param.productType, tag = param.tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableProductCard, {
        className: "carousel-product-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: tag.tagText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        className: "product-icon",
                        src: PRODUCT_ID_TO_LOGO[productType]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-content",
                children: [
                    productType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: "Recommended product"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-logo-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                    src: PRODUCT_ID_TO_LOGO[productType]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function(param) {
                            var useCase = param.useCase;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                                    useCase
                                ]
                            }, useCase);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-signup-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({
                            buttonSize: button_component.XS,
                            extraData: {
                                tag: tag === null || tag === void 0 ? void 0 : tag.tagText,
                                productType: productType
                            }
                        }, BUTTON_CONFIG_BY_PRODUCT[productType]), {
                            buttonColor: PRODUCT_ID_TO_COLOR[productType],
                            withButtonArrow: false
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var selectable_product_card = (SelectableProductCard);

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousle-arrows/prev-arrow.js

var PrevArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "31",
                cy: "31",
                r: "30.5",
                fill: "#181B34",
                stroke: "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2929 30.2929C17.9024 30.6834 17.9024 31.3166 18.2929 31.7071L24.6569 38.0711C25.0474 38.4616 25.6805 38.4616 26.0711 38.0711C26.4616 37.6805 26.4616 37.0474 26.0711 36.6569L20.4142 31L26.0711 25.3431C26.4616 24.9526 26.4616 24.3195 26.0711 23.9289C25.6805 23.5384 25.0474 23.5384 24.6569 23.9289L18.2929 30.2929ZM43 30L19 30V32H43V30Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var prev_arrow = (PrevArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousle-arrows/arrow.scss.js



var ARROW_TYPES = {
    PREV: "prev",
    NEXT: "next"
};
var StyledArrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wz8ppn0"
})("height:100%;background:", function(param) {
    var type = param.type;
    return type === ARROW_TYPES.PREV ? "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);" : "linear-gradient(270deg, #FFF 0%, rgba(255, 255, 255, 0.00) 90.42%);";
}, "  position:absolute;top:0;", function(param) {
    var type = param.type;
    return type === ARROW_TYPES.PREV ? "left: 0;" : "right: 0;";
}, ";width:200px;z-index:1;.carousel-arrow-wrapper{&:hover{svg circle{stroke:white;}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousle-arrows/prev-carousel-arrow.js







var PrevCarouselArrow = function(param) {
    var className = param.className, onClick = param.onClick, pause = param.pause;
    var onPrevArrowClick = function() {
        if (onClick) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "prev"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrow, {
        type: ARROW_TYPES.PREV,
        className: "overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            onMouseEnter: pause,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_arrow, {})
        })
    });
};
/* harmony default export */ var prev_carousel_arrow = (PrevCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousle-arrows/next-arrow.js

var NextArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "31",
                cy: "31",
                r: "30.5",
                transform: "matrix(-1 0 0 1 62 0)",
                fill: "#181B34",
                stroke: "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.7071 30.2929C44.0976 30.6834 44.0976 31.3166 43.7071 31.7071L37.3431 38.0711C36.9526 38.4616 36.3195 38.4616 35.9289 38.0711C35.5384 37.6805 35.5384 37.0474 35.9289 36.6569L41.5858 31L35.9289 25.3431C35.5384 24.9526 35.5384 24.3195 35.9289 23.9289C36.3195 23.5384 36.9526 23.5384 37.3431 23.9289L43.7071 30.2929ZM19 30L43 30V32H19V30Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var next_arrow = (NextArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousle-arrows/next-carousel-arrow.js







var NextCarouselArrow = function(param) {
    var className = param.className, onClick = param.onClick, pause = param.pause;
    var onNextArrowClick = function() {
        if (onClick) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "next"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrow, {
        type: ARROW_TYPES.NEXT,
        className: "overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onMouseEnter: pause,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_arrow, {})
        })
    });
};
/* harmony default export */ var next_carousel_arrow = (NextCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousel-tags-component.scss.js

var StyledCarouselTagsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezn51xx0"
})(".carousel{.slick-slider .slick-list .slick-track{padding-top:0;display:flex;.slick-slide{width:auto !important;}}&.slick-active{.carousel-arrow-wrapper{border-color:transparent;}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-tags/carousel-tags-component.js
function carousel_tags_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_tags_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_tags_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_tags_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_tags_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_tags_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var CarouselTagsComponent = function(param) {
    var _cards = param.cards, cards = _cards === void 0 ? [] : _cards, autoPlay = param.autoPlay, isInView = param.isInView, tagsCarouselProps = param.tagsCarouselProps;
    var slider = (0,react.useRef)(null);
    var isAutoPlay = (0,react.useMemo)(function() {
        return isInView && !!autoPlay.enable;
    }, [
        isInView,
        autoPlay.enable
    ]);
    var carouselProps = {
        items: cards,
        defaultIndex: 0,
        autoplay: isAutoPlay,
        autoplaySpeed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.autoplaySpeed,
        speed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.speed,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_carousel_arrow, {
            pause: function() {
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        }),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_carousel_arrow, {
            pause: function() {
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselTagsComponent, {
        onMouseLeave: function() {
            var _slider_current;
            return isAutoPlay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.play());
        },
        className: "carousel-tags-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, carousel_tags_component_object_spread_props(carousel_tags_component_object_spread({}, CAROUSEL_PROPS, carouselProps, tagsCarouselProps), {
            ref: slider
        }))
    });
};
/* harmony default export */ var carousel_tags_component = (CarouselTagsComponent);

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/desktop-carousel-tags-component.scss.js



var StyledDesktopCarouselTagsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12hsy5z0"
})("	.carousel{&.slick-active{.carousel-arrow-wrapper{border-color:transparent;}}.carousel-arrow-wrapper.slick-arrow{opacity:1;transition:opacity 0.5s ease-in-out;height:fit-content;width:fit-content;z-index:", z_index/* TOP_LAYER */.nA, ";&:focus{outline:none;}&.next{right:60px;}&.prev{left:60px;}}}@media (max-width:", vp_sizes/* MID_HEADER_DESKTOP_MENU */.vc, "px){.carousel{.carousel-arrow-wrapper.slick-arrow{&.next{right:40px;}&.prev{left:40px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/useNumberOfSlides.js



var SLIDE_WIDTH = CARD_WIDTH + 2 * CARD_HORIZONTAL_MARGIN;
var SMALLER_SLIDE_WIDTH = SMALLER_CARDS_WIDTH + 2 * CARD_HORIZONTAL_MARGIN;
var getSlideWidth = function(windowWidth) {
    return windowWidth >= vp_sizes/* MD_DESKTOP */.Dp ? SLIDE_WIDTH : SMALLER_SLIDE_WIDTH;
};
var useNumberOfSlides = function() {
    var ref = (0,react.useState)( true && window.innerWidth), windowWidth = ref[0], setWindowWidth = ref[1];
    var numberOfSlides = (0,react.useMemo)(function() {
        return windowWidth ? windowWidth / getSlideWidth(windowWidth) : undefined;
    }, [
        windowWidth
    ]);
    (0,react.useEffect)(function() {
        var handleResize = function() {
            return setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return numberOfSlides;
};

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/desktop-carousel-tags-component.js
function desktop_carousel_tags_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_carousel_tags_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_carousel_tags_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function desktop_carousel_tags_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function desktop_carousel_tags_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        desktop_carousel_tags_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var DesktopCarouselTagsComponent = function(_param) {
    var cards = _param.cards, rest = _object_without_properties(_param, [
        "cards"
    ]);
    var slidesToShow = useNumberOfSlides(cards.length);
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_product_card, desktop_carousel_tags_component_object_spread({}, card));
    };
    var tagsCarouselProps = {
        itemRenderer: itemRenderer,
        slidesToShow: slidesToShow
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesktopCarouselTagsComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_tags_component, desktop_carousel_tags_component_object_spread_props(desktop_carousel_tags_component_object_spread({}, rest), {
            cards: cards,
            tagsCarouselProps: tagsCarouselProps
        }))
    });
};
/* harmony default export */ var desktop_carousel_tags_component = (DesktopCarouselTagsComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/mobile-carousel-tags/mobile-carousel-tags-component.scss.js

var StyledMobileCarouselTagsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16oy8iq0"
})();

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/mobile-carousel-tags/mobile-cards/mobile-card.scss.js




var StyledMobileCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9beiwr0"
})("border-radius:12px;background-color:#343751;padding:4px;position:relative;overflow:hidden;margin:0 4px;.picture-wrapper{.picture-component{display:flex;img{border-radius:8px;width:100%;}}}.card-content{width:100%;padding:16px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;background-color:#343751;.paragraph-wrapper{.paragraph-body{font-size:1.5rem;font-weight:600;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}.use-cases-wrapper{display:flex;flex-wrap:wrap;flex-direction:column;gap:4px;padding-top:16px;.use-case{display:flex;gap:4px;align-items:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/mobile-carousel-tags/mobile-cards/mobile-card.js





var MobileCard = function(param) {
    var useCases = param.useCases, cardAsset = param.cardAsset, tag = param.tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileCard, {
        className: "mobile-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: tag === null || tag === void 0 ? void 0 : tag.tagText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function(param) {
                            var useCase = param.useCase;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                                    useCase
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mobile_card = (MobileCard);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/mobile-carousel-tags/mobile-carousel-tags-component.js
function mobile_carousel_tags_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_carousel_tags_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_carousel_tags_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_carousel_tags_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_carousel_tags_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_carousel_tags_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var MobileCarouselTagsComponent = function(props) {
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_card, mobile_carousel_tags_component_object_spread({}, card));
    };
    var tagsCarouselProps = {
        itemRenderer: itemRenderer,
        arrows: false,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        waitForAnimate: false,
        fade: false,
        infinite: false,
        draggable: false,
        speed: 500
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileCarouselTagsComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_tags_component, mobile_carousel_tags_component_object_spread_props(mobile_carousel_tags_component_object_spread({}, props), {
            tagsCarouselProps: tagsCarouselProps
        }))
    });
};
/* harmony default export */ var mobile_carousel_tags_component = (MobileCarouselTagsComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-component.js




var CarouselSelectableProductCardsGridComponent = (0,responsive_hoc_component/* default */.Z)(desktop_carousel_tags_component, mobile_carousel_tags_component);
CarouselSelectableProductCardsGridComponent.defaultProps = default_props;
/* harmony default export */ var carousel_selectable_product_cards_grid_component = (CarouselSelectableProductCardsGridComponent);


/***/ })

}]);